export const typeData = [
  {
    id: '1',
    cateName: '活頁夾',
    swiperBlock: [
      {
        title: '可自由組合的收藏品活頁夾',
        sub: '搭配另外販售的補充袋使用，就算是較有厚度的物品也能整齊收納。',
        src: [
          {
            pcWebp: 'case-1-1-desktop.webp',
            pcJpg: 'case-1-1-desktop.jpg',
            rwdWebp: 'case-1-1.webp',
            rwdJpg: 'case-1-1.jpg',
          },
          {
            pcWebp: 'case-1-2-desktop.webp',
            pcJpg: 'case-1-2-desktop.jpg',
            rwdWebp: 'case-1-2.webp',
            rwdJpg: 'case-1-2.jpg',
          },
        ],
        list: ['可挑選多種補充袋自行搭配', '具有厚實的封面，能保護寶貴的收藏品', '單手就能簡單開闔的線圈式設計'],
        productName: '口袋內頁收藏活頁夾/A4寬型.4孔',
        productPic: '4550583766689_1260.jpg',
        price: '250',
        href: 'https://api.91app.com/es/Redirect/41566/4550583766689',
      },
    ],
    listTopBlock: [
      {
        id: 'type1',
        type: 'large',
        list: [
          {
            tabs: [
              {
                title: 'A4寬型',
                img: ['4550583766689_1260.jpg'],
                name: ['口袋內頁收藏活頁夾/A4寬型.4孔'],
                price: ['250'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766689'],
              },
            ],
          },
          {
            tabs: [
              {
                title: 'A5寬型',
                img: ['4550583766696_1260.jpg'],
                name: ['口袋內頁收藏活頁夾/A5寬型.20孔'],
                price: ['190'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766696'],
              },
            ],
          },
        ],
      },
    ],
    listBottomBlock: [
      {
        title: '瀏覽所有可挑選的補充袋',
        content: '可依照自己收集的收藏品挑選適合的補充袋。<br>※不可與收藏活頁夾之外的活頁夾互換使用。',
        block: [
          {
            type: 'small',
            list: [
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f0f6f6',
                        text: '透明資料夾',
                      },
                    ],
                    img: ['4550583766719_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/2口袋.A4寬型用.2入'],
                    price: ['110'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766719'],
                  },
                  {
                    title: ' A5寬型',
                    tag: [
                      {
                        bgColor: '#f0f6f6',
                        text: '透明資料夾',
                      },
                    ],
                    img: ['4550583766795_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/2口袋.A5寬型用.2入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766795'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f4f8f0',
                        text: '明信片',
                      },
                    ],
                    img: ['4550583766726_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/4口袋.A4寬型用.2入'],
                    price: ['110'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766726'],
                  },
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f4f8f0',
                        text: '明信片',
                      },
                    ],
                    img: ['4550583766801_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/4口袋.A5寬型用.2入'],
                    price: ['79'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '徽章',
                      },
                      {
                        bgColor: '#f9f8ef',
                        text: '鑰匙圈',
                      },
                    ],
                    img: ['4550583766818_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/6口袋(大3/小2/迷你1).A5寬型用.2入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766818'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '徽章',
                      },
                      {
                        bgColor: '#f9f8ef',
                        text: '鑰匙圈',
                      },
                    ],
                    img: ['4550583766740_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/6口袋.A4寬型用.2入'],
                    price: ['110'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766740'],
                  },
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '徽章',
                      },
                      {
                        bgColor: '#f9f8ef',
                        text: '鑰匙圈',
                      },
                    ],
                    img: ['4550583766825_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/6口袋.A5寬型用.2入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766825'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '徽章',
                      },
                      {
                        bgColor: '#f9f8ef',
                        text: '鑰匙圈',
                      },
                    ],
                    img: ['4550583766733_1260.jpg'],
                    name: ['收藏活頁夾用補充袋/12口袋.A4寬型用.2入'],
                    price: ['110'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766733'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f0f6f6',
                        text: '拍立得',
                      },
                    ],
                    img: ['4550583766757_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(拍立得尺寸)/9口袋.A4寬型用.10入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766757'],
                  },
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f0f6f6',
                        text: '拍立得',
                      },
                    ],
                    img: ['4550583766832_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(拍立得尺寸)/4口袋.A5寬型用.10入'],
                    price: ['49'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766832'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '明信片',
                      },
                    ],
                    img: ['4550583766771_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(明信片尺寸)/4口袋.A4寬型用.10入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766771'],
                  },
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f9f8ef',
                        text: '明信片',
                      },
                    ],
                    img: ['4550583766856_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(明信片尺寸)/2口袋.A5寬型用.10入'],
                    price: ['49'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766856'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    tag: [
                      {
                        bgColor: '#f4f8f0',
                        text: '遊戲卡',
                      },
                    ],
                    img: ['4550583766764_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(遊戲卡尺寸)/9口袋.A4寬型用.10入'],
                    price: ['79'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766764'],
                  },
                  {
                    title: 'A5寬型',
                    tag: [
                      {
                        bgColor: '#f4f8f0',
                        text: '遊戲卡',
                      },
                    ],
                    img: ['4550583766849_1260.jpg'],
                    name: ['收藏活頁夾用補充袋(遊戲卡尺寸)/4口袋.A5寬型用.10入'],
                    price: ['49'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766849'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '2',
    cateName: '徽章、壓克力立牌、鑰匙圈收納',
    swiperBlock: [
      {
        title: '抑制厚度，不佔空間的多層式口袋夾',
        sub: '即便是壓克力立牌、鑰匙圈等稍有厚度的物品也能俐落地收納。',
        src: [
          {
            pcWebp: 'accessories-1-1-desktop.webp',
            pcJpg: 'accessories-1-1-desktop.jpg',
            rwdWebp: 'accessories-1-1.webp',
            rwdJpg: 'accessories-1-1.jpg',
          },
          {
            pcWebp: 'accessories-1-2-desktop.webp',
            pcJpg: 'accessories-1-2-desktop.jpg',
            rwdWebp: 'accessories-1-2.webp',
            rwdJpg: 'accessories-1-2.jpg',
          },
        ],
        list: ['收納時不會因口袋重疊而變得太厚的樣式', '能保護內容物的附夾鏈口袋', '有2種尺寸的口袋，可收納大小不一的物品'],
        productName: '多層式資料夾',
        productPic: '4550583767068_1260.jpg',
        price: '150',
        href: 'https://api.91app.com/es/Redirect/41566/4550583767068',
      },
      {
        title: '也可用來收納徽章的附口袋補充袋',
        sub: '可依照欲收納的物品挑選尺寸。6個口袋的款式可放入直徑76mm，12個口袋的則可放入直徑57mm的徽章。',
        src: [
          {
            pcWebp: 'accessories-2-1-desktop.webp',
            pcJpg: 'accessories-2-1-desktop.jpg',
            rwdWebp: 'accessories-2-1.webp',
            rwdJpg: 'accessories-2-1.jpg',
          },
          {
            pcWebp: 'accessories-2-2-desktop.webp',
            pcJpg: 'accessories-2-2-desktop.jpg',
            rwdWebp: 'accessories-2-2.webp',
            rwdJpg: 'accessories-2-2.jpg',
          },
        ],
        list: ['厚實的素材能確實保護寶貴的物品', '即使將徽章裝入現有的保護套也能直接放入收納', '附有易放入卻不易掉出的背蓋'],
        productName: '收藏活頁夾用補充袋/6口袋.A4寬型用.2入',
        productPic: '4550583766740_1260.jpg',
        price: '110',
        href: 'https://api.91app.com/es/Redirect/41566/4550583766740',
      },
    ],
    listTopBlock: [
      {
        id: 'type2',
        type: 'small',
        list: [
          {
            tabs: [
              {
                title: '',
                img: ['4550583767068_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '壓克力立牌',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '鑰匙圈',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '徽章',
                  },
                ],
                name: ['多層式資料夾'],
                price: ['150'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767068'],
              },
            ],
          },
          {
            tabs: [
              {
                title: 'A4寬型',
                img: ['4550583766740_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '徽章',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '鑰匙圈',
                  },
                ],
                name: ['收藏活頁夾用補充袋/6口袋.A4寬型用.2入'],
                price: ['110'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766740'],
              },
              {
                title: 'A5寬型',
                img: ['4550583766825_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '徽章',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '鑰匙圈',
                  },
                ],
                name: ['收藏活頁夾用補充袋/6口袋.A5寬型用.2入'],
                price: ['79'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766825'],
              },
            ],
          },
          {
            tabs: [
              {
                title: 'A4寬型',
                img: ['4550583766733_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '徽章',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '鑰匙圈',
                  },
                ],
                name: ['收藏活頁夾用補充袋/12口袋.A4寬型用.2入'],
                price: ['110'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766733'],
              },
            ],
          },
          {
            tabs: [
              {
                title: 'A5寬型',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '徽章',
                  },
                  {
                    bgColor: '#f9f8ef',
                    text: '鑰匙圈',
                  },
                ],
                img: ['4550583766818_1260.jpg'],
                name: ['收藏活頁夾用補充袋/6口袋(大3/小2/迷你1).A5寬型用.2入'],
                price: ['79'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766818'],
              },
            ],
          },
        ],
      },
    ],
    listBottomBlock: [
      {
        title: '瀏覽專用的活頁夾',
        content: '可剛好將收藏活頁夾用補充袋裝進去的活頁夾。<br>能統整收納、攜帶喜愛的物品。',
        block: [
          {
            type: 'large',
            list: [
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    img: ['4550583766689_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A4寬型.4孔'],
                    price: ['250'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766689'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A5寬型',
                    img: ['4550583766696_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A5寬型.20孔'],
                    price: ['190'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766696'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '3',
    cateName: '遊戲卡、明信片收納',
    swiperBlock: [
      {
        title: '可清楚看到內容物的遊戲卡用補充袋',
        sub: '使用了高透明度的素材，可整齊收納喜愛物品的補充袋。<br>可連同現有的保護套一起收納，確實保護珍貴的物品。',
        src: [
          {
            pcWebp: 'card-1-1-desktop.webp',
            pcJpg: 'card-1-1-desktop.jpg',
            rwdWebp: 'card-1-1.webp',
            rwdJpg: 'card-1-1.jpg',
          },
        ],
        list: ['高透明度的素材能讓人清楚看見內容物', '可連同現有的保護套一起收納'],
        productName: '收藏活頁夾用補充袋(遊戲卡尺寸)/9口袋.A4寬型用.10入',
        productPic: '4550583766764_1260.jpg',
        price: '79',
        href: 'https://api.91app.com/es/Redirect/41566/4550583766764',
      },
      {
        unsold: true,
        title: '可將喜歡的相片或遊戲卡立起裝飾的卡夾',
        sub: '平時可當成IC卡夾使用。出遊時可將卡片立起，連同內側的卡片一起拍照。',
        src: [
          {
            pcWebp: 'card-2-1-desktop.webp',
            pcJpg: 'card-2-1-desktop.jpg',
            rwdWebp: 'card-2-1.webp',
            rwdJpg: 'card-2-1.jpg',
          },
          {
            pcWebp: 'card-2-2-desktop.webp',
            pcJpg: 'card-2-2-desktop.jpg',
            rwdWebp: 'card-2-2.webp',
            rwdJpg: 'card-2-2.jpg',
          },
          {
            pcWebp: 'card-2-3-desktop.webp',
            pcJpg: 'card-2-3-desktop.jpg',
            rwdWebp: 'card-2-3.webp',
            rwdJpg: 'card-2-3.jpg',
          },
        ],
        list: ['扣上子母扣就能自行站立的樣式', '外側可收納1張，內側可收納2張卡片', '附有可拉長的伸縮拉繩'],
        productName: '立式卡片夾(附伸縮拉繩)',
        productPic: '4550583767327_1260.jpg',
        price: '390',
        href: 'https://api.91app.com/es/Redirect/41566/4550583767327',
      },
      {
        title: '一個動作就能全部展開的卡片收納夾',
        sub: '因為能簡單地展開並瀏覽全部內容物，是在想一口氣欣賞所有喜愛卡片時推薦使用的卡夾。',
        src: [
          {
            poster: 'video1-poster.jpg',
            video: 'video1.mp4',
          },
          {
            pcWebp: 'card-3-2-desktop.webp',
            pcJpg: 'card-3-2-desktop.jpg',
            rwdWebp: 'card-3-2.webp',
            rwdJpg: 'card-3-2.jpg',
          },
          {
            pcWebp: 'card-3-3-desktop.webp',
            pcJpg: 'card-3-3-desktop.jpg',
            rwdWebp: 'card-3-3.webp',
            rwdJpg: 'card-3-3.jpg',
          },
        ],
        list: ['一個動作就能輕易展開的卡夾', '可一次瀏覽所有卡片', '摺起收納時尺寸相當小'],
        productName: '方便瀏覽全開型收藏卡夾(遊戲卡尺寸)/15口袋(3行x5列)',
        productPic: '4550583767020_1260.jpg',
        price: '110',
        href: 'https://api.91app.com/es/Redirect/41566/4550583767020',
      },
      {
        title: '一個動作就可立起裝飾的卡片收納夾',
        sub: '可立起裝飾、並排拍照，或放置成能同時瀏覽所有喜愛卡片的樣貌。',
        src: [
          {
            poster: 'video2-poster.jpg',
            video: 'video2.mp4',
          },
          {
            pcWebp: 'card-4-2-desktop.webp',
            pcJpg: 'card-4-2-desktop.jpg',
            rwdWebp: 'card-4-2.webp',
            rwdJpg: 'card-4-2.jpg',
          },
          {
            pcWebp: 'card-4-3-desktop.webp',
            pcJpg: 'card-4-3-desktop.jpg',
            rwdWebp: 'card-4-3.webp',
            rwdJpg: 'card-4-3.jpg',
          },
        ],
        list: ['一個動作就能輕易展開的卡夾', '可立起放置或拍照的蛇腹式設計', '摺起收納時尺寸相當小'],
        productName: '方便瀏覽可立式收藏卡夾(明信片尺寸)/10口袋',
        productPic: '4550583767051_1260.jpg',
        price: '140',
        href: 'https://api.91app.com/es/Redirect/41566/4550583767051',
      },
      {
        unsold: true,
        title: '可裝飾並收納喜愛照片的展示盒',
        sub: '俐落收納佔空間的照片及卡片類物品時，將喜愛的照片當做封面裝飾，也可幫助辨識內容物。',
        src: [
          {
            pcWebp: 'card-5-1-desktop.webp',
            pcJpg: 'card-5-1-desktop.jpg',
            rwdWebp: 'card-5-1.webp',
            rwdJpg: 'card-5-1.jpg',
          },
          {
            pcWebp: 'card-5-2-desktop.webp',
            pcJpg: 'card-5-2-desktop.jpg',
            rwdWebp: 'card-5-2.webp',
            rwdJpg: 'card-5-2.jpg',
          },
        ],
        list: ['此商品樣式可幫助辨識內容物，或用來裝飾喜愛的照片', '約可收納150張 ※不含保護套 ※此為收納明信片時的張數'],
        productName: '收藏卡片展示盒(明信片尺寸)',
        productPic: '4550583767549_1260.jpg',
        price: '220',
        href: 'https://api.91app.com/es/Redirect/41566/4550583767549',
      },
    ],
    listTopBlock: [
      {
        id: 'type3',
        type: 'small',
        list: [
          {
            tabs: [
              {
                title: 'A4寬型',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '明信片',
                  },
                ],
                img: ['4550583766771_1260.jpg'],
                name: ['收藏活頁夾用補充袋(明信片尺寸)/4口袋.A4寬型用.10入'],
                price: ['79'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766771'],
              },
              {
                title: 'A5寬型',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '明信片',
                  },
                ],
                img: ['4550583766856_1260.jpg'],
                name: ['收藏活頁夾用補充袋(明信片尺寸)/2口袋.A5寬型用.10入'],
                price: ['49'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766856'],
              },
            ],
          },
          {
            tabs: [
              {
                title: 'A4寬型',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                img: ['4550583766764_1260.jpg'],
                name: ['收藏活頁夾用補充袋(遊戲卡尺寸)/9口袋.A4寬型用.10入'],
                price: ['79'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766764'],
              },
              {
                title: 'A5寬型',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                img: ['4550583766849_1260.jpg'],
                name: ['收藏活頁夾用補充袋(遊戲卡尺寸)/4口袋.A5寬型用.10入'],
                price: ['49'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766849'],
              },
            ],
          },
          {
            tabs: [
              {
                unsold: true,
                title: '',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                img: ['4550583767334_1260.jpg', '4550583767327_1260.jpg', '4550583767310_1260.jpg'],
                chips: [
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767334',
                    src: '4550583767334_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767327',
                    src: '4550583767327_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767310',
                    src: '4550583767310_99_95.jpg',
                  },
                ],
                name: ['立式卡片夾(附伸縮拉繩)/苔綠', '立式卡片夾(附伸縮拉繩)/象牙白', '立式卡片夾(附伸縮拉繩)/黑'],
                price: ['390', '390', '390'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767297', 'https://api.91app.com/es/Redirect/41566/4550583767303', 'https://api.91app.com/es/Redirect/41566/4550583767310'],
              },
            ],
          },
          {
            tabs: [
              {
                title: '明信片',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '明信片',
                  },
                ],
                img: ['4550583767037_1260.jpg'],
                name: ['方便瀏覽全開型收藏卡夾(明信片尺寸)/12口袋(3行x4列)'],
                price: ['140'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767037'],
              },
              {
                title: '遊戲卡',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                img: ['4550583767020_1260.jpg'],
                name: ['方便瀏覽全開型收藏卡夾(遊戲卡尺寸)/15口袋(3行x5列)'],
                price: ['110'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767020'],
              },
            ],
          },
          {
            tabs: [
              {
                title: '明信片',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '明信片',
                  },
                ],
                img: ['4550583767051_1260.jpg'],
                name: ['方便瀏覽可立式收藏卡夾(明信片尺寸)/10口袋'],
                price: ['140'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767051'],
              },
              {
                title: '遊戲卡',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                img: ['4550583767044_1260.jpg'],
                name: ['方便瀏覽可立式收藏卡夾(遊戲卡尺寸)/10口袋'],
                price: ['110'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767044'],
              },
            ],
          },
          {
            tabs: [
              {
                unsold: true,
                title: '',
                tag: [
                  {
                    bgColor: '#f9f8ef',
                    text: '明信片',
                  },
                ],
                chips: [
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767549',
                    src: '4550583767549_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767556',
                    src: '4550583767556_99_95.jpg',
                  },
                ],
                name: ['收藏卡片展示盒(明信片尺寸)/米', '收藏卡片展示盒(明信片尺寸)/深灰'],
                price: ['220', '220'],
                img: ['4550583767549_1260.jpg', '4550583767556_1260.jpg'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767549', 'https://api.91app.com/es/Redirect/41566/4550583767556'],
              },
            ],
          },
          {
            tabs: [
              {
                unsold: true,
                title: '',
                tag: [
                  {
                    bgColor: '#f4f8f0',
                    text: '遊戲卡',
                  },
                ],
                chips: [
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767525',
                    src: '4550583767525_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767532',
                    src: '4550583767532_99_95.jpg',
                  },
                ],
                name: ['收藏卡片展示盒(遊戲卡尺寸)/米', '收藏卡片展示盒(遊戲卡尺寸)/深灰'],
                price: ['190', '190'],
                img: ['4550583767525_1260.jpg', '4550583767532_1260.jpg'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767525', 'https://api.91app.com/es/Redirect/41566/4550583767532'],
              },
            ],
          },
        ],
      },
    ],
    listBottomBlock: [
      {
        title: '瀏覽專用的活頁夾',
        content: '可剛好將收藏活頁夾用補充袋裝進去的活頁夾。<br>能統整收納、攜帶喜愛的物品。',
        block: [
          {
            type: 'large',
            list: [
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    img: ['4550583766689_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A4寬型.4孔'],
                    price: ['250'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766689'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A5寬型',
                    img: ['4550583766696_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A5寬型.20孔'],
                    price: ['190'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766696'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '4',
    cateName: '拍立得、透明資料夾收納',
    swiperBlock: [
      {
        title: '能清楚瀏覽照片的拍立得用補充袋',
        sub: '使用了高透明度的素材，可整齊收納喜愛物品的補充袋。<br>可連同現有的保護套一起收納，確實保護珍貴的物品。',
        src: [
          {
            pcWebp: 'cheki-1-1-desktop.webp',
            pcJpg: 'cheki-1-1-desktop.jpg',
            rwdWebp: 'cheki-1-1.webp',
            rwdJpg: 'cheki-1-1.jpg',
          },
        ],
        list: ['高透明度的素材能讓人清楚看見內容物', '可連同現有的保護套一起收納'],
        productName: '收藏活頁夾用補充袋(拍立得尺寸)/9口袋.A4寬型用.10入',
        productPic: '4550583766757_1260.jpg',
        price: '79',
        href: 'https://api.91app.com/es/Redirect/41566/4550583766757',
      },
    ],
    listTopBlock: [
      {
        id: 'type4',
        type: 'large',
        list: [
          {
            tabs: [
              {
                title: 'A4寬型',
                img: ['4550583766757_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f0f6f6',
                    text: '拍立得',
                  },
                ],
                name: ['收藏活頁夾用補充袋(拍立得尺寸)/9口袋.A4寬型用.10入'],
                price: ['79'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766757'],
              },
              {
                title: 'A5寬型',
                img: ['4550583766757_1260.jpg'],
                tag: [
                  {
                    bgColor: '#f0f6f6',
                    text: '拍立得',
                  },
                ],
                name: ['收藏活頁夾用補充袋(拍立得尺寸)/4口袋.A5寬型用.10入'],
                price: ['49'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583766757'],
              },
            ],
          },
          // {
          //   tabs: [
          //     {
          //       title: 'A4寬型',
          //       img: ['4550583766757_1260.jpg'],
          //       tag: [
          //         {
          //           bgColor: '#f0f6f6',
          //           text: '拍立得',
          //         },
          //       ],
          //       name: ['收藏活頁夾用補充袋(拍立得尺寸)/9口袋.A4寬型用.10入'],
          //       price: ['79'],
          //       href: ['https://api.91app.com/es/Redirect/41566/4550583766757'],
          //     },
          //   ],
          // },
        ],
      },
    ],
    listBottomBlock: [
      {
        title: '瀏覽專用的活頁夾',
        content: '可剛好將收藏活頁夾用補充袋裝進去的活頁夾。<br>能統整收納、攜帶喜愛的物品。',
        block: [
          {
            type: 'large',
            list: [
              {
                tabs: [
                  {
                    title: 'A4寬型',
                    img: ['4550583766689_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A4寬型.4孔'],
                    price: ['250'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766689'],
                  },
                  {
                    title: 'A5寬型',
                    img: ['4550583766689_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A4寬型.4孔'],
                    price: ['250'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766689'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: 'A5寬型',
                    img: ['4550583766696_1260.jpg'],
                    name: ['口袋內頁收藏活頁夾/A5寬型.20孔'],
                    price: ['190'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550583766696'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    id: '5',
    cateName: '絨毛玩具、小物展示',
    swiperBlock: [
      {
        unsold: true,
        title: '可用來攜帶喜愛物品的絨毛玩具收納包',
        sub: '也可收納具有厚度的小物，且附有方便的吊繩，可輕易攜帶。',
        src: [
          {
            pcWebp: 'display-1-1-desktop.webp',
            pcJpg: 'display-1-1-desktop.jpg',
            rwdWebp: 'display-1-1.webp',
            rwdJpg: 'display-1-1.jpg',
          },
          {
            pcWebp: 'display-1-2-desktop.webp',
            pcJpg: 'display-1-2-desktop.jpg',
            rwdWebp: 'display-1-2.webp',
            rwdJpg: 'display-1-2.jpg',
          },
        ],
        list: ['厚度多達7cm，具有厚度的絨毛玩具和小物也可裝入', '附有可掛在包包上攜帶的吊繩'],
        productName: '吊掛展示收納包',
        productPic: '4550583855130_1260.jpg',
        price: '390',
        href: 'https://api.91app.com/es/Redirect/41566/4550583855130',
      },
    ],
    listTopBlock: [
      {
        id: 'type5',
        type: 'small',
        list: [
          {
            tabs: [
              {
                unsold: true,
                title: '',
                img: ['4550583855130_1260.jpg', '4550583767303_1260.jpg', '4550583767297_1260.jpg'],
                chips: [
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583855130',
                    src: '4550583855130_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767303',
                    src: '4550583767303_99_95.jpg',
                  },
                  {
                    href: 'https://api.91app.com/es/Redirect/41566/4550583767297',
                    src: '4550583767297_99_95.jpg',
                  },
                ],
                name: ['吊掛展示收納包/苔綠', '吊掛展示收納包/象牙白', '吊掛展示收納包/黑'],
                price: ['390', '390', '390'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583855130', 'https://api.91app.com/es/Redirect/41566/4550583767303', 'https://api.91app.com/es/Redirect/41566/4550583767297'],
              },
            ],
          },
          {
            tabs: [
              {
                unsold: true,
                title: '方型',
                img: ['4550583767440_1260.jpg'],
                name: ['壓克力ㄇ字展示架.方型.3入組'],
                price: ['249'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767440'],
              },
              {
                unsold: true,
                title: '寬型',
                img: ['4550583767433_1260.jpg'],
                name: ['壓克力ㄇ字展示架.寬型.3入組'],
                price: ['249'],
                href: ['https://api.91app.com/es/Redirect/41566/4550583767433'],
              },
            ],
          },
        ],
      },
    ],
    listBottomBlock: [
      {
        title: '瀏覽其他推薦的展示用商品',
        block: [
          {
            type: 'small',
            list: [
              {
                tabs: [
                  {
                    title: '',
                    img: ['4550002856120_1260.jpg'],
                    name: ['壓克力展示盒(附門).小'],
                    price: ['699'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550002856120'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: '',
                    img: ['4550002856113_1260.jpg'],
                    name: ['壓克力展示盒(附門).大'],
                    price: ['799'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550002856113'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    unsold: true,
                    title: '',
                    img: ['4945247381115_1260.jpg'],
                    name: ['壓克力收納展示盒(4×4格)'],
                    price: ['899'],
                    href: ['https://api.91app.com/es/Redirect/41566/4945247381115'],
                  },
                ],
              },
              {
                tabs: [
                  {
                    title: '',
                    img: ['4550344310250_1260.jpg'],
                    name: ['木製展示盒.附門'],
                    price: ['990'],
                    href: ['https://api.91app.com/es/Redirect/41566/4550344310250'],
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
];
